import React from 'react';
import { useNavigate } from 'react-router-dom';

interface EmptyStateProps {
  message: string;
  buttonLabel: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ message, buttonLabel }) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/tractor-poking/list');
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      navigate('/tractor-poking/list');
    }
  };

  return (
    <div className={'flex flex-col items-center justify-center py-16'}>
      <svg
        width={'60'}
        height={'62'}
        viewBox={'0 0 60 62'}
        fill={'none'}
        xmlns={'http://www.w3.org/2000/svg'}
        className={'mb-2'}
      >
        <mask
          id={'mask0_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask0_1_48285)'}>
          <path d={'M6.931 52.529L26.94 46.057V17.051L6.931 23.468V52.529Z'} fill={'#ECECF3'} />
        </g>
        <mask
          id={'mask1_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask1_1_48285)'}>
          <path d={'M50.529 22.036L26.927 17.051L34.29 24.157L58 29.169L50.529 22.049V22.036Z'} fill={'#E0E0EB'} />
        </g>
        <mask
          id={'mask2_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask2_1_48285)'}>
          <path d={'M50.718 51.11L26.94 46.057V17.051L50.718 22.104V51.11Z'} fill={'#E0E0EB'} />
        </g>
        <mask
          id={'mask3_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask3_1_48285)'}>
          <path
            d={
              'M46.57 45.355L25.116 40.802C24.576 40.694 24.197 40.208 24.197 39.667V16.267C24.197 15.632 24.724 15.105 25.359 15.105C25.44 15.105 25.521 15.105 25.602 15.132L47.056 19.685C47.596 19.793 47.975 20.279 47.975 20.82V44.22C47.975 44.855 47.462 45.382 46.813 45.382C46.732 45.382 46.651 45.382 46.57 45.355Z'
            }
            fill={'#ECECF3'}
          />
        </g>
        <mask
          id={'mask4_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask4_1_48285)'}>
          <path
            d={
              'M44.395 46.03L22.941 41.477C22.401 41.369 22.022 40.883 22.022 40.342V16.942C22.022 16.307 22.549 15.78 23.184 15.78C23.265 15.78 23.346 15.78 23.427 15.807L44.881 20.36C45.421 20.468 45.8 20.954 45.8 21.495V44.895C45.8 45.53 45.273 46.057 44.638 46.057C44.557 46.057 44.476 46.057 44.395 46.03Z'
            }
            fill={'#E0E0EB'}
          />
        </g>
        <mask
          id={'mask5_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask5_1_48285)'}>
          <path
            d={
              'M42.261 46.733L20.806 42.18C20.266 42.072 19.887 41.586 19.887 41.045V17.645C19.887 17.01 20.414 16.483 21.049 16.483C21.13 16.483 21.211 16.483 21.292 16.51L42.746 21.063C43.286 21.171 43.665 21.657 43.665 22.198V45.598C43.665 46.233 43.152 46.76 42.503 46.76C42.423 46.76 42.342 46.76 42.261 46.733Z'
            }
            fill={'#ECECF3'}
          />
        </g>
        <mask
          id={'mask6_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask6_1_48285)'}>
          <path
            d={
              'M40.085 47.408L18.631 42.855C18.091 42.747 17.712 42.261 17.712 41.72V18.307C17.712 17.672 18.239 17.145 18.874 17.145C18.955 17.145 19.036 17.145 19.117 17.172L40.571 21.725C41.111 21.833 41.49 22.319 41.49 22.86V46.26C41.49 46.895 40.963 47.422 40.328 47.422C40.247 47.422 40.166 47.422 40.085 47.395V47.408Z'
            }
            fill={'#E0E0EB'}
          />
        </g>
        <mask
          id={'mask7_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask7_1_48285)'}>
          <path
            d={
              'M37.924 34.722L16.47 30.169C15.93 30.061 15.551 29.575 15.551 29.034V5.63398C15.551 4.98598 16.064 4.47198 16.713 4.47198C16.794 4.47198 16.875 4.47199 16.956 4.49899L38.41 9.05299C38.95 9.16098 39.329 9.64698 39.329 10.188V33.588C39.329 34.223 38.802 34.75 38.167 34.75C38.086 34.749 38.005 34.749 37.924 34.722Z'
            }
            fill={'#ECECF3'}
          />
        </g>
        <mask
          id={'mask8_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask8_1_48285)'}>
          <path
            d={
              'M35.749 35.397L14.295 30.844C13.755 30.736 13.376 30.25 13.376 29.709V6.30998C13.376 5.67498 13.903 5.14798 14.538 5.14798C14.619 5.14798 14.7 5.14798 14.781 5.17498L36.235 9.72798C36.775 9.83598 37.154 10.322 37.154 10.863V34.263C37.154 34.898 36.641 35.425 35.992 35.425C35.911 35.424 35.83 35.424 35.749 35.397Z'
            }
            fill={'#E0E0EB'}
          />
        </g>
        <mask
          id={'mask9_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask9_1_48285)'}>
          <path
            d={
              'M33.614 49.529L12.16 44.976C11.62 44.868 11.241 44.382 11.241 43.841V20.441C11.241 19.806 11.768 19.279 12.403 19.279C12.484 19.279 12.565 19.279 12.646 19.306L34.1 23.86C34.64 23.968 35.019 24.454 35.019 24.995V48.395C35.019 49.03 34.492 49.557 33.857 49.557C33.776 49.556 33.695 49.556 33.614 49.529Z'
            }
            fill={'#ECECF3'}
          />
        </g>
        <mask
          id={'mask10_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask10_1_48285)'}>
          <path
            d={
              'M31.439 50.205L9.98499 45.652C9.44499 45.544 9.06599 45.058 9.06599 44.517V21.104C9.06599 20.469 9.59299 19.942 10.228 19.942C10.309 19.942 10.39 19.942 10.471 19.969L31.925 24.522C32.465 24.63 32.844 25.116 32.844 25.657V49.057C32.844 49.692 32.331 50.219 31.682 50.219C31.601 50.219 31.52 50.219 31.439 50.192V50.205Z'
            }
            fill={'#E0E0EB'}
          />
        </g>
        <mask
          id={'mask11_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask11_1_48285)'}>
          <path d={'M30.709 57.541L50.718 51.07V22.05L30.709 28.521V57.527V57.541Z'} fill={'#BABDCA'} />
        </g>
        <mask
          id={'mask12_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask12_1_48285)'}>
          <path d={'M36.748 37.654L56.757 31.183L50.718 22.05L30.709 28.521L36.748 37.654Z'} fill={'#ECECF3'} />
        </g>
        <mask
          id={'mask13_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask13_1_48285)'}>
          <path d={'M30.709 57.527L6.931 52.474V23.468L30.709 28.521V57.527Z'} fill={'#E0E0EB'} />
        </g>
        <mask
          id={'mask14_1_48285'}
          style={{ maskType: 'luminance' }}
          maskUnits={'userSpaceOnUse'}
          x={'2'}
          y={'4'}
          width={'56'}
          height={'54'}
        >
          <path d={'M58 4.47299H2V57.528H58V4.47299Z'} fill={'white'} />
        </mask>
        <g mask={'url(#mask14_1_48285)'}>
          <path d={'M2 32.52L6.931 23.468L30.709 28.521L25.71 37.532L2 32.52Z'} fill={'#ECECF3'} />
        </g>
      </svg>

      <p className={'text-[14px] font-normal leading-[150%] text-[#858894] mb-4'}>{message}</p>

      <button
        onClick={handleClick}
        onKeyDown={handleKeyPress}
        className={
          'w-[167px] max-h-[40px] px-4 py-4 border border-gray-300 rounded-lg text-[14px] font-medium leading-[85%] text-gray-700 bg-white flex items-center justify-center'
        }
        aria-label={buttonLabel}
      >
        <span>{buttonLabel}</span>
        <svg
          width={'14'}
          height={'14'}
          viewBox={'0 0 14 14'}
          fill={'none'}
          xmlns={'http://www.w3.org/2000/svg'}
          className={'ml-1'}
        >
          <path
            d={
              'M4.26999 12.6699C4.05999 12.6699 3.84999 12.5999 3.70999 12.4599C3.42999 12.1799 3.49999 11.7599 3.77999 11.4799L8.74999 7.13989L3.77999 2.65989C3.49999 2.37989 3.42999 1.95989 3.70999 1.67989C3.98999 1.39989 4.40999 1.32989 4.68999 1.60989L10.29 6.50989C10.43 6.64989 10.5 6.85989 10.5 7.06989C10.5 7.27989 10.43 7.48989 10.29 7.62989L4.68999 12.5299C4.54999 12.5999 4.40999 12.6699 4.26999 12.6699Z'
            }
            fill={'#505363'}
          />
        </svg>
      </button>
    </div>
  );
};

export default EmptyState;
